("use strict");
import {
  fixedDepositsConstants,
  generalBillPaymentsConstants,
} from "../_constants";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, exhaustMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError } from "../_actions";

import {
  otpConfirmationComplete,
  otpConfirmationError,
  payableListComplete,
  payableListError,
  payBillComplete,
  payBillError,
  payeeCategoriesListComplete,
  payeeCategoriesListError,
  payeeTypesListComplete,
  payeeTypesListError,
  validateBillAccountNumberError,
  validateBillAccountNumberComplete,
  validateBillAmountError,
  validateBillAmountomplete,
  resendOtpError,
  resendOtpComplete,
} from "../_actions//generalBillPayments.actions";

export const payeeCategoriesListEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/getPyeeCategoriesList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            payeeCategoriesListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(payeeCategoriesListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const payeeTypesGeneralListEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.PAYEE_TYPES_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/getPyeeTypesList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => payeeTypesListComplete(ajaxResponse.response)),
          catchError((error) =>
            of(payeeTypesListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const payableListEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.PAYABLE_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/getPayableList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => payableListComplete(ajaxResponse.response)),
          catchError((error) => of(payableListError(error), ajaxError(error))),
        );
    }),
  );

export const validateBillAccountNumberEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/validateBillAccountNumber",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            validateBillAccountNumberComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(validateBillAccountNumberError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const validateBillAmountEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/validateBillAmount",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            validateBillAmountomplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(validateBillAmountError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const payBillGeneralEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.GENERAL_PAY_BILL_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/payBill",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => payBillComplete(ajaxResponse.response)),
          catchError((error) => of(payBillError(error), ajaxError(error))),
        );
    }),
  );

export const optConfirmationBillEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.OTP_CONFIRMATION_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/otpConfirmation",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => otpConfirmationComplete(ajaxResponse.response)),
          catchError((error) =>
            of(otpConfirmationError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const resendOtpEpic = (actions$) =>
  actions$.pipe(
    ofType(generalBillPaymentsConstants.BILL_PAYMENTS_OTP_RESEND_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/generalBillPayments/otpResend",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => resendOtpComplete(ajaxResponse.response)),
          catchError((error) => of(resendOtpError(error), ajaxError(error))),
        );
    }),
  );
